export enum DisplayMode {
    main = 1,
    product = 2
}